import { render, staticRenderFns } from "./OzlOrderViewDialog.vue?vue&type=template&id=2c7296ec&scoped=true"
import script from "./OzlOrderViewDialog.vue?vue&type=script&lang=js"
export * from "./OzlOrderViewDialog.vue?vue&type=script&lang=js"
import style0 from "./OzlOrderViewDialog.vue?vue&type=style&index=0&id=2c7296ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7296ec",
  null
  
)

export default component.exports